<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    固戍站<br>
站点介绍<br>
车站位于宝安大道与固戍二道交叉路口，沿宝安大道中呈“一字型”布置。线路呈南北走向。 固戍站东北角为上围新村。西北角为南昌第二新村，西南方为工业区，东西方为下围新村和红湾新村。该站为地下站。<br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:28	23:07	1号线	2分钟	4分40秒<br>
机场东	06:13	00:01	1号线	2分钟	4分40秒<br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:27	23:07	1号线	3分45秒	5分45秒<br>
机场东	06:19	23:59	1号线	3分45秒	5分45秒<br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:27	00:07	1号线	3分45秒	5分45秒<br>
机场东	06:19	00:59	1号线	3分45秒	5分45秒<br>

站点出口信息<br>
A出入口:<br>
福永、沙井、松岗方向、宝安大道、107国道、置富广场、宝富大厦、固戍华庭、人人乐、固戍大门、三围、上围园、石街新村、机场10号线、黄田、九围新村、上围园新村、汉庭酒店、田心工业园、固戍一路、嘉喜时代广场、南昌第一村、前进二路、松源大厦、上岛咖啡、联升百货、梧桐岛、菜市场、新中泰<br><br>
C出入口:<br>
中信领航、加油站、万象新天、桃源居、安居家园<br><br>
D出入口:<br>
航城大道、华丰工业园<br><br>
E出入口:<br>
固戍二路北侧、宝安大道西侧、航城大道南侧、华丰工业园<br><br>
F出入口:<br>
西乡方向、固戍大门、下围园、7天连锁酒店、固戍幼儿园、固戍花园、碧海湾、海滨新村、固戍华庭、黄麻布、银田工业区、华方工业区、下围园新村、新天地、南昌公园、宝园路、西乡客运站、固戍村、南昌工业区、西乡人民医院<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 固戍地铁站<br>
338、615、高快巴士21、旅游9线、B888、M194、M245、M247环线、M259、M433、M473、M527Q2、M527Q1、M527、M528Q、M528、M530、M558<br><br>
F出入口:<br>
公交站名： 固戍地铁站<br>
338、615、B887、B888、B976、M194、M245、M247环线、M259、M393Q、M393、M433、M473、M527Q1、M527Q2、M528Q、M528、M530、M558、旅游9线、高快巴士21<br><br>
E出入口:<br>
公交站名： 华丰工业区公交站①<br>
338、615、B887、B888、B976、M194、M245、M247环线、M259、M433、M473、M527Q1、M527Q2、M527、M528、M530、M558<br><br>
D出入口:<br>
公交站名： 华丰工业区公交站②<br>
338、615、B887、B888、B976、M194、M245、M247环线、M259、M393、M433、M473、M527Q1、M527Q2、M527、M528Q、M528、M530、M558<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>